export * from './app-breadcrumbs.component';



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/components/app-breadcrumbs/index.ts